import React from "react";
import { Snackbar, Alert, AlertColor, SnackbarOrigin } from "@mui/material";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "./styles.scss";

interface SnackbarNotificationProps {
  open: boolean;
  message: string;
  severity?: AlertColor;
  onClose: () => void;
  duration?: number;
  position?: SnackbarOrigin;
  action?: React.ReactNode;
}

const SnackbarNotification: React.FC<SnackbarNotificationProps> = ({
  open,
  message,
  severity = "success",
  onClose,
  duration = 6000,
  position = { vertical: "top", horizontal: "center" },
  action,
}) => {
  const getBackgroundColor = () => {
    switch (severity) {
      case "success":
        return "#16a34a";
      case "error":
        return "#ED4F9D";
      case "warning":
        return "#ffc107";
      case "info":
      default:
        return "#0288d1";
    }
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={duration}
      onClose={onClose}
      anchorOrigin={position}
      className={s.snackbarRoot}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        variant="filled"
        className={s.alert}
        action={action}
        sx={{
          width: "100%",
          minWidth: "300px",
          backgroundColor: getBackgroundColor(),
          boxShadow: "0 3px 5px -1px rgba(0,0,0,0.2), 0 6px 10px 0 rgba(0,0,0,0.14), 0 1px 18px 0 rgba(0,0,0,0.12)",
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default withStyles(s)(SnackbarNotification);